exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#box[data-v-60dae427] {\n\twidth: 60%;\n\tmargin: 50px auto 40px auto;\n}\n", ""]);

// exports
